<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">コンテナ種別検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load" v-permit.SHARP_CT_SEARCH class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0111/new" v-permit.SHARP_CT_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_CT_EDIT.SHARP_CT_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-permit.SHARP_CT_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="コンテナタイプ" v-model="query.code"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="コンテナ名称" v-model="query.name"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="最大積載M3" v-model="query.max"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">コンテナ種別</h3>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :rows-per-page-items="[10]"
        class="elevation-0"
        hide-actions
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.locales.ja_JP }}</td>
          <td>{{ props.item.max }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    query: {
      code: '',
      name: '',
      max: ''
    },
    items: [],
    selected: [],
    headers: [
      { text: 'コンテナタイプ', value: 'code', sortable: false },
      { text: '名称', value: 'name', sortable: false },
      { text: '最大積載M3', value: 'max', sortable: false }
    ]
  }),
  methods: {
    load() {
      this.$storeParams()
      this.$http.get('/container-types', { params: this.query }).then(res => {
        this.items = res.data
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0111',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/container-types/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
    //this.load()
  }
}
</script>